import { Facet } from "../../../components/results/components/productsResults/components/facets/components/facet/@types/facet.types";
import { FacetType } from "../../../components/results/components/productsResults/components/facets/components/facet/@types/facetType.types";
import {
    FACET_DELIMITER,
    FACET_VALUE_STORE_STOCK_IDENTIFIER
} from "../../../components/results/components/productsResults/components/facets/components/facet/facet.configuration";

export const isShowProductsFacet = (
    facet: Facet<FacetType>
): facet is Facet<FacetType.SHOW_PRODUCTS> => {
    return facet.type === FacetType.SHOW_PRODUCTS;
};

export const isStoreStockFacetValue = (value: string) => {
    return value.startsWith(FACET_VALUE_STORE_STOCK_IDENTIFIER);
};

export const createStoreStockFacetValue = (storeId?: string) => {
    return `${FACET_VALUE_STORE_STOCK_IDENTIFIER}${FACET_DELIMITER}${storeId}`;
};
